import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from '../../../services/menu.service';
import { ConfirmationService } from 'primeng/api';
import { SkeletonModule } from 'primeng/skeleton';
import { MenuSaveComponent } from '../menu-save/menu-save.component';
import { MenuItemListComponent } from '../menu-item-list/menu-item-list.component';
import { PanelModule } from '../../../modules/panel.module';
import { Utility } from '../../../core/common';
import { BusinessListComponent } from '../../business/business-list/business-list.component';
import { MenuItemOptionComponent } from '../menu-item-option/menu-item-option.component';

@Component({
  selector: 'brt-menu-list',
  standalone: true,
  imports: [PanelModule, SkeletonModule, BusinessListComponent, MenuSaveComponent, MenuItemListComponent, MenuItemOptionComponent],
  providers: [ConfirmationService],
  templateUrl: './menu-list.component.html',
  styleUrl: './menu-list.component.scss'
})
export class MenuListComponent {
  basePath = this.route.snapshot.data['basePath'] || '/';
  constructor(public router: Router, private route: ActivatedRoute, private menuService: MenuService,
    private confirmationService: ConfirmationService) {
    route.params.subscribe(async params => {
      this.criteria = { BusinessId: params['bid'] };
    });
  }

  loading: boolean = true;
  menus: any[];
  total: number;
  criteria: any = {};

  menu: any;

  menuDialog: boolean;
  menuOptionDialog: boolean;
  menuItemDialog: boolean;

  async load(event?: any) {
    if (!this.criteria.BusinessId) return;
    this.loading = true;

    this.criteria = {
      BusinessId: this.criteria.BusinessId,
      Query: this.criteria.Query?.trim() || null,
      From: event?.first || 0,
      Size: event?.rows || 10
    };

    var result = await this.menuService.searchMenu(this.criteria);
    this.menus = result.List;
    this.total = result.Total;
    this.menus.forEach(_ => {
      _._actions = [
        {
          label: 'Default Item Options', command: () => { this.menu = Utility.clone(_); this.menuOptionDialog = true; }
        },
        // { label: 'Menu Items', command: () => { this.menu = Utility.clone(_); this.menuItemDialog = true; } },
        { label: 'Menu Items', routerLink: [this.basePath, 'menu', this.criteria.BusinessId, _.Id, 'item'] },
        { separator: true },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => this.deleteMenu(_) },
        // { label: 'Edit', icon: 'pi pi-fw pi-pencil', routerLink: [this.basePath, 'menu', this.businessId, _.Id] },
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => { this.menu = Utility.assign(_, { _tab: 0 }); this.menuDialog = true; } },
      ];
    });
    this.loading = false;
  }

  async setOrder() {
    var indexess: { [id: string]: number } = {};
    for (var i = 0; i < this.menus.length; i++) {
      let index = this.criteria.From + i;
      if (this.menus[i].Order != index)
        indexess[this.menus[i].Id] = index;
    }
    await this.menuService.setMenuIndex(indexess);
  }

  async deleteMenu(menu: any) {
    this.confirmationService.confirm({
      key: 'confirmPopup',
      target: document.getElementById('action-menu-' + menu.Id),
      message: 'Are you sure that you want to delete this menu?',
      icon: 'pi pi-exclamation-triangle',
      accept: async () => {
        await this.menuService.deleteMenu(menu.Id);
        await this.load();
      }
    });
  }

  async save() {
    await this.menuService.saveMenu(this.menu);
    await this.load();
  }
}
